import _get from 'lodash/get';
import { AttachmentValue, UppyFile } from '../types';

export default function getAttachmentVariables(
  file: UppyFile,
): AttachmentValue {
  const filename = _get(file, 'response.body.data.metadata.filename', '');
  return {
    // id: file.id,
    filename,
    file: {
      id: _get(file, 'response.body.data.id', ''),
      storage: _get(file, 'response.body.data.storage', 'cache') as string,
      metadata: {
        size: _get(file, 'response.body.data.metadata.size', 1),
        filename,
        mimeType: _get(file, 'response.body.data.metadata.mime_type', ''),
      },
    },
    url: _get(file, 'response.body.url', '') as string,
  };
}
